import React from 'react';
import { graphql, useStaticQuery } from "gatsby";
import Main from '../Layout/Main';
import { Helmet } from 'react-helmet';
import CoverImage from '../CoverImage';
import TextBlock from '../TextBlock/TextBlock';
import PressQuotes from '../PressQuotes/PressQuotes';
import PhotoGrid from '../PhotoGrid';
import LargeEditorial from '../LargeEditorial';
import SmallBoxes from '../SmallBoxes/SmallBoxes';
import ImageBlocks from '../ImageBlocks';
import Carousel from  '../Carousel/Carousel';

const LittleCaesars = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query LittleCaesarsQuery {
      markdownRemark(frontmatter: { pageId: { eq: "caesars-page" } }) {
        frontmatter {
          components {
            type
            id
            deeplink
            variant
            content {
              videoSlides {
                video {
                  src
                  loop
                  autoplay
                  controls
                  caption
                }
              }
              logo {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              video {
                src
                loop
                autoplay
                controls
              }
              copy {
                leader
                caption
                trailer
                quotes {
                  line
                  source
                }
                body {
                  line
                }
                subheads {
                  line
                }
                headlines {
                  line
                }
                scriptHeadline {
                  line
                }
                blocks {
                  headline
                  headlines {
                    line
                  }
                  leader
                  headline2
                  bullets {
                    bullet
                  }
                  body2 {
                    line
                  }
                  type
                  image
                  icon {
                    childImageSharp {
                      fluid(maxWidth: 2048, quality: 80) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                    extension
                    publicURL
                  }
                  body {
                    line
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const availComponents = {
    CoverImage,
    TextBlock,
    PressQuotes,
    PhotoGrid,
    LargeEditorial,
    SmallBoxes,
    ImageBlocks,
    Carousel
  }

  const renderComponents = () => {
    const components = markdownRemark.frontmatter.components;
    let hydratedComponents = [];
    components.forEach((component, i) => {
      const ComponentRef = availComponents[component.type];
      const deeplinkId = component.deeplink ? component.id : '';
      hydratedComponents.push(<ComponentRef key={i} id={deeplinkId} variant={component.variant} {...component.content}/>)
    })
    return hydratedComponents
  }

  return (
    <Main>
      <Helmet>
        <body className="page ram-page" />
      </Helmet>
      {renderComponents()}
    </Main>
  )
}

export default LittleCaesars;
